import { HelpCircle } from "iconoir-react";

import { createIcon } from "../create-icon";

export const IconHelpCircle12Line = createIcon(HelpCircle, 12, "Line");
export const IconHelpCircle16Line = createIcon(HelpCircle, 16, "Line");
export const IconHelpCircle20Line = createIcon(HelpCircle, 20, "Line");
export const IconHelpCircle24Line = createIcon(HelpCircle, 24, "Line");
export const IconHelpCircle32Line = createIcon(HelpCircle, 32, "Line");
export const IconHelpCircle48Line = createIcon(HelpCircle, 48, "Line");
export const IconHelpCircle64Line = createIcon(HelpCircle, 64, "Line");
